import {
	calcPerpetualRentTotal,
	calcRentToZeroTotal,
} from "web_myplann/Goals/Helpers/rentCalculation";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";

type RentTotalInput = {
	monthly: number;
	drawdownMode: RentDrawdownMode;
	rentYears: number;
};

export const getRentTotal = ({
	monthly,
	drawdownMode,
	rentYears,
}: RentTotalInput): number =>
	drawdownMode === RentDrawdownMode.Perpetual
		? calcPerpetualRentTotal(monthly)
		: calcRentToZeroTotal(monthly, rentYears);
